'use client';
import { useMediaQuery } from '@react-hookz/web';

import { usePaywallContext } from '~context/paywall';
import { PaymentReason } from '~features/annals';
import { annals } from '~features/annals/hooks';
import { useSluggedPathname } from '~hooks/useSluggedPathname';
import { buildFullUrl } from '~shared/ui/molecules/ImageRenderer/utils';

import { usePromoEventNeurons } from '../../hooks/usePromoEventNeurons';
import { usePromoEventSubscription } from '../../hooks/usePromoEventSubscription';
import { ClickableArea, Container, PromoEventImage } from './styles';

export const PromoEventButton = () => {
	const reasonType = annals.checkout.usePaymentReasonType();
	const isMobile = useMediaQuery('screen and (max-width: 767px)');
	const { openPaywall } = usePaywallContext();
	const [pathname, sluggedPathname] = useSluggedPathname();
	const hideOnMobileSingleChat = isMobile && sluggedPathname.includes('botId');
	const {
		promoMembershipActive,
		isLoading: isMembershipDataLoading,
		data: membershipData,
		activeOnPages: membershipActiveOnPages,
	} = usePromoEventSubscription();

	const {
		promoNeuronsActive,
		isLoading: isNeuronsDataLoading,
		data: neuronsData,
		activeOnPages: neuronsActiveOnPages,
	} = usePromoEventNeurons();

	const offerType = promoMembershipActive
		? 'membership'
		: promoNeuronsActive
		? 'neurons'
		: undefined;

	let image;
	let imageAlt;
	let defaultPromocode;
	switch (offerType) {
		case 'membership':
			image = membershipData.buttonImageUrl;
			imageAlt = 'Promo event membership button';
			defaultPromocode = membershipData.promocode;
			break;
		case 'neurons':
			image = neuronsData.buttonImageUrl;
			imageAlt = 'Promo event neurons button';
			defaultPromocode = neuronsData.promocode;
			break;
		default:
			break;
	}
	const handleClick = openPaywall({
		reason: PaymentReason.PromoEvent,
		reasonType,
		prefer: promoMembershipActive ? 'subscription' : 'neurons',
		defaultPromocode,
	});

	if (
		isMembershipDataLoading ||
		isNeuronsDataLoading ||
		!image ||
		!imageAlt ||
		hideOnMobileSingleChat
	) {
		return null;
	}

	if (
		!!membershipActiveOnPages &&
		offerType === 'membership' &&
		!membershipActiveOnPages.includes(pathname)
	) {
		return null;
	}

	if (
		!!neuronsActiveOnPages &&
		offerType === 'neurons' &&
		!neuronsActiveOnPages.includes(pathname)
	) {
		return null;
	}

	return (
		<Container>
			<PromoEventImage
				src={buildFullUrl(image)}
				width={200}
				height={200}
				alt={imageAlt}
				unoptimized={true}
			/>
			<ClickableArea onClick={handleClick} />
		</Container>
	);
};
